import { CheckSquare } from 'lucide-react';
import { useStaffDashboard } from '../hooks';
import { DataView } from '../../../components/ui/DataView';
import { Card } from '../../../components/ui/Card';
import type { PeriodOption } from '@repo/shared-dashboard';

interface TaskActivityWidgetProps {
  period?: PeriodOption;
}

export function TaskActivityWidget({ period = 'month' }: TaskActivityWidgetProps) {
  const query = useStaffDashboard(period);

  return (
    <Card className="p-5 flex flex-col justify-between h-full">
      <div className="flex items-center justify-between border-b border-border pb-3 mb-4">
        <h3 className="text-sm font-semibold text-text-primary">Task Activities</h3>
      </div>
      <DataView query={query} isEmpty={() => false}>
        {(data) => {
          const tasks = data?.taskActivity ?? [];
          if (tasks.length === 0) {
            return (
              <div className="py-8 flex flex-col items-center justify-center text-center my-auto">
                <div className="w-10 h-10 rounded-full bg-surface-2 flex items-center justify-center text-text-muted mb-2.5">
                  <CheckSquare className="w-5 h-5 opacity-70" />
                </div>
                <p className="text-sm font-semibold text-text-primary">No Task Activity</p>
                <p className="text-xs text-text-muted mt-1 max-w-[240px]">Collection assignments and field tasks will appear here</p>
              </div>
            );
          }

          return (
            <div>
              <div className="relative border-l border-border ml-2 pl-4 space-y-6">
                {tasks.map((task) => (
                  <div key={task.id} className="relative">
                    <div
                      className={`absolute -left-[21px] top-1 w-2.5 h-2.5 rounded-full border border-surface-1 ${
                        task.type === 'success'
                          ? 'bg-success-500'
                          : task.type === 'info'
                            ? 'bg-info-500'
                            : task.type === 'warning'
                              ? 'bg-warning-500'
                              : task.type === 'danger'
                                ? 'bg-danger-500'
                                : 'bg-surface-3'
                      }`}
                    />
                    <p className="text-xs font-semibold text-text-muted">{task.date}</p>
                    <p className="text-sm text-text-primary mt-1">{task.description}</p>
                  </div>
                ))}
              </div>
            </div>
          );
        }}
      </DataView>
    </Card>
  );
}

